import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

import NavBar from "../../components/navBar/navBar";
import MyMapComponent from "../../components/GoogleMap";
import Geocode from "react-geocode";
import AddNotification from "../../components/Modals/AddNotification";
import ShowNotificationModal from "../../components/Modals/ShowNotificationModal";
import { LoaderContext } from "../../context/LoaderContext";
import { __API_URL__ } from "../../SERVER_URL";
import useUser from "../../hooks/user";
import Loader from "../../components/Loader";

import {
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import SearchIcon from "@mui/icons-material/Search";

const Clinic = () => {
  Geocode.setApiKey("AIzaSyBykNn93LjLI2MEv2PGOnSfpD_11zi1q30");
  Geocode.enableDebug();
  const token = localStorage.getItem("token");
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const user = useUser();
  const loaderContext = useContext(LoaderContext);

  const [initialLoading, setInitialLoading] = useState(true);
  const [initialOwnersList, setInitialOwnersList] = useState([]);
  const [clinicList, setClinicList] = useState([]);
  const [ownersList, setOwnersList] = useState([]);
  const [adminsList, setAdminsList] = useState([]);
  const [AddEmail, setAddEmail] = useState([]);
  const [addClinicCheck, setAddClinicCheck] = useState(false);
  const [addNotificationOpen, setAddNotificationOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [clinicDetails, setClinicDetails] = useState({
    name: "",
    phone: "",
    address: "",
    lat: 0,
    lng: 0,
    owner_details: {},
    owner:
      user_data.role === "Clinic Owner"
        ? user_data.id
        : user_data.role === "Clinic Admin"
          ? user_data.owner_id
          : "",
    clinic_emails: [],
    rewards: false,
  });

  const changeClinicDetails = (latt, lngg, Address) => {
    setClinicDetails((prev) => ({
      ...prev,
      lat: latt,
      lng: lngg,
      address: Address,
    }));
  };

  const AllClinics = () => {
    return axios
      .get(`${__API_URL__}/api/clinic/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => setClinicList(res.data))
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
          user.actions.logout();
        }
      });
  };

  const AllOwners = () => {
    return axios
      .get(`${__API_URL__}/api/owners_list/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => setInitialOwnersList(res.data))
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
          user.actions.logout();
        }
      });
  };

  const AllAdmins = (clinicId) => {
    axios
      .get(`${__API_URL__}/api/clinicAdminslist/${clinicId}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => setAdminsList(res.data))
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
          user.actions.logout();
        }
      });
  };

  const UpdateClinic = async (id) => {
    loaderContext.setLoaderCount((prev) => prev + 1);
    await axios
      .patch(`${__API_URL__}/api/clinic/${id}/`, clinicDetails, {
        headers: { Authorization: `Token ${token}` },
      })
      .then(() => {
        toast.success("Clinic Updated Successfully");
        AllClinics();
        setShowDetails(0);
      })
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
          user.actions.logout();
        } else {
          toast.error("Clinic Update Failed");
        }
      })
      .finally(() => loaderContext.setLoaderCount((prev) => prev - 1));
  };

  useEffect(() => {
    Promise.all([AllClinics(), AllOwners()]).finally(() => setInitialLoading(false));
  }, []);

  const [showDetails, setShowDetails] = useState(0);

  const selectClinic = (clinicId) => {
    setAddClinicCheck(false);
    if (Number(showDetails) === Number(clinicId)) {
      setShowDetails(0);
      return;
    }
    const clinic = clinicList.find((x) => Number(x.id) === Number(clinicId));
    if (!clinic) return;
    setClinicDetails({
      ...clinic,
      lat: clinic?.location?.latitude,
      lng: clinic?.location?.longitude,
      clinic_emails: clinic?.clinic_emails ? clinic?.clinic_emails.split(",") : "",
    });
    if (clinic?.owner_details) {
      setOwnersList(initialOwnersList.filter((owner) => owner.id !== clinic?.owner_details.id));
    }
    setShowDetails(clinicId);
    clinic?.clinic_email
      ? setAdminsList([{ value: clinic?.clinic_email, label: clinic?.clinic_email }])
      : setAdminsList([]);
    AllAdmins(clinicId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClinicDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddClinic = () => {
    setShowDetails(0);
    setAddClinicCheck(true);
    setClinicDetails({
      name: "",
      phone: "",
      address: "",
      owner_details: {},
      owner:
        user_data.role === "Clinic Owner"
          ? user_data.id
          : user_data.role === "Clinic Admin"
            ? user_data.owner_id
            : "",
    });
    setOwnersList(initialOwnersList);
  };

  const cancelAddClinic = () => {
    setAddClinicCheck(false);
  };

  const AddClinicFn = async () => {
    loaderContext.setLoaderCount((prev) => prev + 1);
    axios
      .post(`${__API_URL__}/api/addclinic/`, clinicDetails, {
        headers: { Authorization: `Token ${token}` },
      })
      .then(() => {
        toast.success("Clinic Added Successfully");
        setAddClinicCheck(false);
        setShowDetails(0);
        AllClinics();
      })
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
          user.actions.logout();
        } else {
          toast.error("Clinic Addition Failed");
        }
      })
      .finally(() => loaderContext.setLoaderCount((prev) => prev - 1));
  };

  const handleAddEmail = (e) => {
    setAddEmail(e.target.value);
  };

  const handleAddEmailChange = () => {
    const re =
      /^(([^<>()[\],;:\s@]+([^<>()[\],;:\s@]+)*)|(.+))@(([^<>()[\],;:\s@]+)+[^<>()[\],;:\s@]{2,})$/i;
    if (AddEmail.match(re)) {
      if (clinicDetails?.clinic_emails === null) {
        setClinicDetails({ ...clinicDetails, clinic_emails: [AddEmail] });
      } else {
        setClinicDetails({
          ...clinicDetails,
          clinic_emails: [...clinicDetails?.clinic_emails, AddEmail],
        });
      }
      setAddEmail("");
    } else {
      Swal.fire("Error", "Please provide Correct Email Address");
    }
  };

  const handleCrossEmail = (id) => {
    const newArray = clinicDetails?.clinic_emails.filter((_, index) => index !== id);
    setClinicDetails({ ...clinicDetails, clinic_emails: newArray });
  };

  const filteredClinics = clinicList.filter(
    (c) =>
      c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.address?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const hasSelection = showDetails !== 0 || addClinicCheck;

  return (
    <Box sx={{ maxWidth: "95%", mx: "auto" }}>
      <NavBar active="clinic" />

      {initialLoading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "calc(100vh - 64px)",
            overflow: "hidden",
          }}
        >
          {/* ---- LEFT SIDEBAR: Clinic List ---- */}
          <Paper
            elevation={0}
            sx={{
              width: 320,
              minWidth: 320,
              borderRight: "1px solid",
              borderColor: "divider",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box sx={{ p: 2, pb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  mb: 1.5,
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleAddClinic}
                >
                  Add Clinic
                </Button>
              </Box>
              <TextField
                size="small"
                fullWidth
                placeholder="Search clinics..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Box>

            <Divider />

            <List
              sx={{
                flex: 1,
                overflow: "auto",
                py: 0,
              }}
            >
              {filteredClinics.length > 0 ? (
                filteredClinics.map((clinic) => {
                  const isSelected = Number(showDetails) === Number(clinic?.id);
                  return (
                    <ListItemButton
                      key={clinic?.id}
                      selected={isSelected}
                      onClick={() => selectClinic(clinic?.id)}
                      sx={{
                        py: 1.5,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        "&.Mui-selected": {
                          bgcolor: "primary.50",
                          borderLeft: "3px solid",
                          borderLeftColor: "primary.main",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          bgcolor: isSelected ? "primary.main" : "action.hover",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 1.5,
                          flexShrink: 0,
                        }}
                      >
                        <LocalHospitalIcon
                          fontSize="small"
                          sx={{
                            color: isSelected ? "white" : "text.secondary",
                          }}
                        />
                      </Box>
                      <ListItemText
                        primary={clinic?.name}
                        secondary={clinic?.address}
                        primaryTypographyProps={{
                          variant: "subtitle2",
                          noWrap: true,
                          fontWeight: isSelected ? 700 : 500,
                        }}
                        secondaryTypographyProps={{
                          variant: "caption",
                          noWrap: true,
                        }}
                      />
                    </ListItemButton>
                  );
                })
              ) : (
                <Box sx={{ p: 3, textAlign: "center" }}>
                  <Typography variant="body2" color="text.secondary">
                    {searchTerm ? "No clinics match your search." : "No clinics found."}
                  </Typography>
                </Box>
              )}
            </List>
          </Paper>

          {/* ---- RIGHT PANEL: Details / Add Form / Empty State ---- */}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              bgcolor: "grey.50",
            }}
          >
            {!hasSelection ? (
              /* Empty state */
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  color: "text.secondary",
                }}
              >
                <LocalHospitalIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
                <Typography variant="h6" color="text.secondary">
                  Select a clinic to view details
                </Typography>
                <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5 }}>
                  Or click "Add" to create a new clinic
                </Typography>
              </Box>
            ) : (
              <Box sx={{ p: 3 }}>
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {addClinicCheck && (
                      <IconButton size="small" onClick={cancelAddClinic}>
                        <ArrowBackIcon />
                      </IconButton>
                    )}
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      {addClinicCheck ? "Add New Clinic" : clinicDetails?.name}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    onClick={() => (addClinicCheck ? AddClinicFn() : UpdateClinic(showDetails))}
                  >
                    {addClinicCheck ? "Submit" : "Update"}
                  </Button>
                </Box>

                {/* Clinic Form */}
                <Paper sx={{ p: 3, mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                    Clinic Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Clinic Name"
                        size="small"
                        fullWidth
                        name="name"
                        value={clinicDetails?.name || ""}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Clinic Phone"
                        size="small"
                        fullWidth
                        type="tel"
                        name="phone"
                        value={clinicDetails?.phone || ""}
                        onChange={handleChange}
                      />
                    </Grid>

                    {user_data.role === "Super Admin" && (
                      <Grid item xs={12} md={6}>
                        <FormControl size="small" fullWidth>
                          <InputLabel>Clinic Owner</InputLabel>
                          <Select
                            label="Clinic Owner"
                            name="owner"
                            value={
                              clinicDetails?.owner_details
                                ? clinicDetails?.owner_details.id || ""
                                : ""
                            }
                            onChange={handleChange}
                          >
                            {!addClinicCheck &&
                            Object.keys(clinicDetails?.owner_details || {}).length !== 0 ? (
                              <MenuItem value={clinicDetails?.owner_details.id}>
                                {clinicDetails?.owner_details.full_name}
                              </MenuItem>
                            ) : (
                              <MenuItem value="" disabled>
                                Select Owner
                              </MenuItem>
                            )}
                            {ownersList.map((owner) => (
                              <MenuItem value={owner.id} key={owner.id}>
                                {owner.full_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={clinicDetails?.rewards || false}
                            onChange={() =>
                              setClinicDetails((prev) => ({
                                ...prev,
                                rewards: !prev?.rewards,
                              }))
                            }
                          />
                        }
                        label="Add Rewards For Subjects"
                      />
                    </Grid>
                  </Grid>
                </Paper>

                {/* Emails section (edit mode only) */}
                {!addClinicCheck && (
                  <Paper sx={{ p: 3, mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                      Email Addresses
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                        mb: 2,
                      }}
                    >
                      <TextField
                        label="Add Email"
                        size="small"
                        type="email"
                        value={AddEmail}
                        onChange={handleAddEmail}
                        sx={{ flex: 1, maxWidth: 360 }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleAddEmailChange();
                          }
                        }}
                      />
                      <Button variant="outlined" onClick={handleAddEmailChange}>
                        Add
                      </Button>
                    </Box>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {clinicDetails?.clinic_emails
                        ? clinicDetails?.clinic_emails.map((item, index) => (
                            <Chip
                              key={index}
                              label={item}
                              onDelete={() => handleCrossEmail(index)}
                              variant="outlined"
                            />
                          ))
                        : null}
                    </Box>
                  </Paper>
                )}

                {/* Map & Address */}
                <Paper sx={{ p: 3, mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                    Location
                  </Typography>
                  <Box
                    sx={{
                      height: 280,
                      width: "100%",
                      mb: 2,
                      borderRadius: 1,
                      overflow: "hidden",
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                  >
                    <MyMapComponent
                      changeClinicDetails={changeClinicDetails}
                      clinicDetails={clinicDetails}
                      isMarkerShown
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBykNn93LjLI2MEv2PGOnSfpD_11zi1q30&v=3.exp&libraries=places"
                      loadingElement={<div style={{ height: "100%" }} />}
                      containerElement={<div style={{ height: "250px" }} />}
                      mapElement={<div style={{ height: "100%" }} />}
                    />
                  </Box>
                  <TextField
                    label="Clinic Address"
                    size="small"
                    fullWidth
                    name="address"
                    value={clinicDetails?.address || ""}
                    onChange={handleChange}
                    slotProps={{ input: { readOnly: true } }}
                  />
                </Paper>

                {/* Notifications & Documents (edit mode only) */}
                {!addClinicCheck && (
                  <NotificationSettings
                    clinicData={clinicList}
                    clinicDetails={clinicDetails}
                    role={user_data.role}
                    user={user}
                    token={token}
                    AllClinics={AllClinics}
                    onAddNotification={() => setAddNotificationOpen(true)}
                  />
                )}
              </Box>
            )}
          </Box>
        </Box>
      )}

      <AddNotification
        open={addNotificationOpen}
        onClose={() => setAddNotificationOpen(false)}
        token={token}
        id={clinicDetails?.id}
        AllClinics={AllClinics}
      />
    </Box>
  );
};

/* ---- Reminder Table ---- */

const REMINDER_COLUMNS = [
  { id: "IsApp", label: "App" },
  { id: "IsSMS", label: "SMS" },
  { id: "IsEmail", label: "Email" },
  { id: "days_before", label: "Days Before" },
  { id: "days_after", label: "Days After" },
  { id: "custom_title", label: "Title" },
];

const BOOL_COLUMNS = new Set(["IsApp", "IsSMS", "IsEmail"]);

const ReminderTable = ({ title, reminders, onRowClick }) => {
  if (!reminders?.length) {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
        <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5 }}>
          No {title.toLowerCase()} configured
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title} ({reminders.length})
      </Typography>
      <TableContainer sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {REMINDER_COLUMNS.map((col) => (
                <TableCell key={col.id} sx={{ fontWeight: 600, bgcolor: "grey.50" }}>
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {reminders.map((item, index) => (
              <TableRow
                key={index}
                hover
                sx={{ cursor: "pointer" }}
                onClick={() => onRowClick(item)}
              >
                {REMINDER_COLUMNS.map((col) => (
                  <TableCell key={col.id}>
                    {BOOL_COLUMNS.has(col.id)
                      ? item[col.id]
                        ? "Yes"
                        : "No"
                      : (item[col.id] ?? "-")}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

/* ---- Notification Settings & Documents ---- */

const NotificationSettings = (props) => {
  const [selectedFile, setSelectedFile] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [fileIsSelected, setFileIsSelected] = useState(false);
  const loaderContext = useContext(LoaderContext);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setFileIsSelected(true);
  };

  const handleFileSubmission = (e) => {
    if (fileIsSelected) {
      e.preventDefault();
      const formData = new FormData();
      formData.append("document", selectedFile);
      formData.append("clinic", props.clinicDetails?.id);

      loaderContext.setLoaderCount((prev) => prev + 1);

      if (props.role === "Super Admin") formData.append("file_type", 1);
      else formData.append("file_type", 2);

      axios
        .post(`${__API_URL__}/api/clinic/file_upload/`, formData, {
          headers: { Authorization: `Token ${props.token}` },
        })
        .then(() => props.AllClinics())
        .catch((err) => {
          if (err === "Error: Request failed with status code 401") {
            props.user.actions.logout();
          }
        })
        .finally(() => loaderContext.setLoaderCount((prev) => prev - 1));
    } else Swal.fire("Error", "Please choose a file");
  };

  const handleDeleteFile = (id) => {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("File Deleted", "", "success");
        DeleteFile(id);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  async function DeleteFile(id) {
    try {
      loaderContext.setLoaderCount((prev) => prev + 1);
      await axios.delete(`${__API_URL__}/api/clinic/delete_file/${id}/`, {
        headers: { Authorization: `Token ${props.token}` },
      });
    } catch (err) {
      if (err === "Error: Request failed with status code 401") {
        props.user.actions.logout();
      }
    } finally {
      loaderContext.setLoaderCount((prev) => prev - 1);
    }
  }

  const handleDeleteNotification = () => {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Notification Deleted", "", "success");
        DeleteNotification();
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  async function DeleteNotification() {
    try {
      loaderContext.setLoaderCount((prev) => prev + 1);
      await axios.delete(`${__API_URL__}/api/clinic/delete_notification/${selectedItem.id}/`, {
        headers: { Authorization: `Token ${props.token}` },
      });
      setModalShow(false);
      props.AllClinics();
    } catch (error) {
      if (error === "Error :Request failed with status code 401") {
        props.user.logout();
      }
    } finally {
      loaderContext.setLoaderCount((prev) => prev - 1);
    }
  }

  const selectedClinic = props.clinicData.find((item) => item?.id === props.clinicDetails?.id);

  const handleAddNotiModal = (item) => {
    setSelectedItem(item);
    setModalShow(true);
  };

  return (
    <>
      {/* Notification Settings */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Subject Notification Settings
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={props.onAddNotification}
          >
            Add Notification
          </Button>
        </Box>

        <ReminderTable
          title="Appointment Reminders"
          reminders={selectedClinic?.appointment_reminders}
          onRowClick={handleAddNotiModal}
        />
        <ReminderTable
          title="Photo Reminders"
          reminders={selectedClinic?.photo_reminders}
          onRowClick={handleAddNotiModal}
        />
        <ReminderTable
          title="General Reminders"
          reminders={selectedClinic?.general_reminders}
          onRowClick={handleAddNotiModal}
        />
      </Paper>

      {/* Documents */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
          Documents
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            p: 2,
            mb: 3,
            border: "1px dashed",
            borderColor: "divider",
            borderRadius: 1,
            bgcolor: "grey.50",
          }}
        >
          <input type="file" name="file" onChange={handleFileChange} required />
          <Button variant="contained" size="small" onClick={handleFileSubmission}>
            Upload
          </Button>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
              }}
            >
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                From Appiell
              </Typography>
              {selectedClinic?.files_by_super?.length ? (
                selectedClinic?.files_by_super.map((item) => (
                  <Box
                    key={item?.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 0.5,
                    }}
                  >
                    <Typography
                      component="a"
                      href={item?.document}
                      download
                      variant="body2"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1,
                        mr: 1,
                      }}
                    >
                      {item?.document}
                    </Typography>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteFile(item?.id)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="text.disabled">
                  No documents found
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
              }}
            >
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                From Clinic
              </Typography>
              <Typography variant="body2" color="text.disabled">
                No document available
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {modalShow ? (
        <ShowNotificationModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          selectedItem={selectedItem}
          handleDelete={handleDeleteNotification}
        />
      ) : null}
    </>
  );
};

export default Clinic;
